import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import "./NotFound.css";

function RelatedPages() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const pageApi = process.env.REACT_APP_PAGES_API_PATH;
  const apiKey = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    axios
      .get(pageApi, {
        headers: { Authorization: `Api-Key ${apiKey}` },
        params: { type: "Case.CaseStudyPage", fields: "title" },
      })
      .then((res) => setCases(res.data.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageApi, apiKey]);

  return (
    <div className="nf-related">
      <div className="nf-related__label">
        <span className="nf-related__line" />
        <span className="nf-related__text">The related pages</span>
        <span className="nf-related__line" />
      </div>

      {loading ? (
        <div className="nf-related__skeleton">
          {[180, 140, 160, 120].map((w) => (
            <div
              key={w}
              className="shimmer nf-related__sk-line"
              style={{ width: w }}
            />
          ))}
        </div>
      ) : (
        <div className="nf-related__list">
          {cases.map((c) => (
            <Link key={c.id} to={`/case/${c.id}`} className="nf-related__item">
              <span className="nf-related__dot" />
              {c.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

function NotFound() {
  return (
    <>
      <section className="nf-hero">
        <div className="nf-hero__inner">
          <div className="nf-code" aria-label="404">
            <span className="nf-code__dark">4</span>
            <span className="nf-code__blue">0</span>
            <span className="nf-code__dark">4</span>
          </div>

          <p className="nf-subtitle">ERROR · PAGE NOT FOUND</p>

          <p className="nf-description">
            This page may have been deleted, moved, or is temporarily
            unavailable.
          </p>
          <Link to="/" className="nf-btn">
            Back
          </Link>
        </div>
      </section>

      <RelatedPages />
    </>
  );
}

export default NotFound;
